import { createContext } from 'react';
import type { BrandFile } from '@hub/common';
import type { ColorModeStorageValue } from 'features/store/localStorage';

// The brand a page shows: its file; `requested` while a participation page
// has no file applied (the participation or its brand file loads, or the file
// failed to load), which keeps it light without brand tokens; undefined for
// the Participant Hub look.
export type PageBrand = BrandFile | 'requested' | undefined;

type ThemeContextProps = {
  savedMode: ColorModeStorageValue;
  setColorMode: (newMode: ColorModeStorageValue) => void;
  // The saved mode applies only while true; otherwise the theme is light.
  darkModeAllowed: boolean;
  // The brand file the current page shows; undefined keeps the Participant
  // Hub look.
  activeBrand: BrandFile | undefined;
  // `requested` keeps a brand file that is already applied.
  setActiveBrand: (brand: PageBrand) => void;
};

export const ThemeContext = createContext<ThemeContextProps | undefined>(
  undefined
);
